import { render, staticRenderFns } from "./PostCloudAccountButton.vue?vue&type=template&id=3dc894f4&"
import script from "./PostCloudAccountButton.vue?vue&type=script&lang=js&"
export * from "./PostCloudAccountButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PostCloudAccountButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports